import ServicePageTemplate from "../components/ServicePageTemplate";
import usePageMeta from "../hooks/usePageMeta";

export default function Bortforsling() {
  usePageMeta({
    title: "Bortforsling av ris och trädgårdsavfall | Trädfällarna Laholm AB",
    description:
      "Bortforsling av ris, grenar och trädgårdsavfall efter trädfällning eller beskärning i Laholm med omnejd.",
  });

  return (
    <ServicePageTemplate
      eyebrow="Tjänst"
      title="Bortforsling av ris, grenar och trädgårdsavfall"
      intro="Efter beskärning eller trädfällning kan vi ta hand om ris, grenar och annat material så att tomten lämnas ren och lätt att använda."
      heroImage="/images/hero.webp"
      bodyHeading="Tomten lämnas ren och städad"
      bodyText="Du slipper själv köra till återvinningen. Vi tar med oss ris, grenar och annat material som blir kvar efter arbetet. Det går också bra att kombinera med fällning, beskärning eller stubbfräsning i samma uppdrag."
      bullets={[
        "Ris och grenar fraktas bort direkt efter arbetet",
        "Trädgårdsavfall hanteras på rätt sätt",
        "Kan kombineras med trädfällning, beskärning eller stubbfräsning",
        "Tomten lämnas städad och lätt att använda",
      ]}
    />
  );
}
